import {
  ActionIcon,
  Button,
  Checkbox,
  Divider,
  Modal,
  Progress,
  SegmentedControl,
  Select,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { INDIA_STATES_UNIONS } from "./constants";
import { DatePicker } from "@mantine/dates";
import { IconFile, IconSearch, IconTrash } from "@tabler/icons-react";
import {
  converDateToISO,
  convertFromISO,
  convertToISO,
  convertToISO8601,
  existsAndLength,
  formatDateString,
  formatDatetoISO,
  formatDatetoIST,
  getFutureDate,
} from "./utilities";
import SignedAgreementListModal from "./SignedAgreementListModal";
import {
  fetchBuOptions,
  fetchRegions,
  getNamesofAgreement,
  getTitlesOfAgreement,
} from "../apis/userApis";
import { showNotification } from "@mantine/notifications";
import AWS from "aws-sdk/global";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../redux/authSlice";
import DocumentsModal from "../componenets/documentsModal";
import {
  attachFiles,
  attachFileToParent,
  getAttacchedFiles,
  getReadUrl,
} from "../apis/fileApi";
import { createLocalAgreement } from "../apis/obligationApi";
import axios from "axios";
import { getCookiesSession } from "../apis/cookiesSession";

const LegacyAgreementForm1 = ({
  uiConfigs,
  setUiConfigs,
  file,
  setFile,
  setDetails,
}) => {
  const typeOfDocuments = [
    "Parent",
    "Supplementary",
    "Supplementary to Supplementary",
  ];
  const dispatch = useDispatch();
  const userData = JSON.parse(getCookiesSession("userData"));
  const [type, setType] = useState("Entity");
  const [useExisting, setUseExisting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [buData, setBuData] = useState(null);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const getBuData = async () => {
      const response = await fetchBuOptions();
      setBuData(response.buData);
    };
    const getRegionData = async () => {
      const response = await fetchRegions();
      setRegions(response.regionData);
    };
    getRegionData();
    getBuData();
  }, []);
  const [secondPartyDetailsEntity, setSecondPartyDetailsEntity] = useState({
    type: "Entity",
    name: "",
    entityType: "",
    regAddress: "",
  });
  const [signedFile, setSignedFile] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [fileBuffer, setFileBuffer] = useState(null);
  const [secondPartyDetailsIndi, setSecondPartyDetailsIndi] = useState({
    type: "Individual",
    indi_name: "",
    fathersname: "",
    pan: "",
  });
  const [agreementData, setAgreementData] = useState({
    agreementId: 0,
    local: true,
    relationshipType: "",
    typeOfAgreement: "",
    titleOfAgreement: "",
    dateOfContract: "",
    noOfMonths: 0,
    noOfYears: 0,
    location: "",
    businessUnit: 0,
    mapRegion: 0,
    secondParty: { type: type },
    errors: {},
    endDate: "",
    createdBy: userData.name,
    createdById: userData.id,
    createdByEmail: userData.email,
    brandName: "",
    jobOrder: "",
    oneDriveId: null,
  });
  const [searchCategory, setSearchCategory] = useState("");
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      const trimmed = searchCategory.trim();
      if (trimmed && !categoryOptions.some((opt) => opt.value === trimmed)) {
        const newOption = { value: trimmed, label: trimmed };
        setCategoryOptions((prev) => [...prev, newOption]);
        setAgreementData((prev) => ({
          ...prev,
          typeOfAgreement: trimmed,
        }));
      }
    }, 500); // 500ms debounce
    return () => clearTimeout(timeout);
  }, [searchCategory]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const trimmed = searchName.trim();
      if (trimmed && !nameOptions.some((opt) => opt.value === trimmed)) {
        const newOption = { value: trimmed, label: trimmed };
        setNameOptions((prev) => [...prev, newOption]);
        setAgreementData((prev) => ({
          ...prev,
          titleOfAgreement: trimmed,
        }));
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchName]);

  useEffect(() => {
    if (type === "Entity") {
      setAgreementData({
        ...agreementData,
        secondParty: secondPartyDetailsEntity,
      });
    } else if (type === "Individual") {
      setAgreementData({
        ...agreementData,
        secondParty: secondPartyDetailsIndi,
      });
    }
  }, [type, secondPartyDetailsEntity, secondPartyDetailsIndi]);

  const [selectedAgreementId, setSelectedAgreementId] = useState(0);
  const [selectedAgreementData, setSelectedAgreementData] = useState({});
  const [docuementModal, setDocumentModal] = useState(false);
  console.log(selectedAgreementId, selectedAgreementData);
  const [categoryOptions, setCategoryOptions] = useState([
    "NDA",
    "Service Agreement",
  ]);
  const [nameOptions, setNameOptions] = useState([
    "truecounsel NDA",
    "tc services",
  ]);

  useEffect(() => {
    const getTitles = async () => {
      const response = await getTitlesOfAgreement();
      if (response.success) {
        setNameOptions(response.titlesOfAgreement);
      }
    };
    const getNames = async () => {
      const response = await getNamesofAgreement();
      if (response.success) {
        setCategoryOptions(response.namesOfAgreement);
      }
    };
    getTitles();
    getNames();
  }, []);

  useEffect(() => {
    if (
      selectedAgreementId > 0 &&
      JSON.stringify(selectedAgreementData).length > 0
    ) {
      setAgreementData({
        ...agreementData,
        agreementId: selectedAgreementId,
        local: false,
        relationshipType: selectedAgreementData.relationshipType,
        typeOfAgreement: selectedAgreementData.typeOfAgreement,
        titleOfAgreement: selectedAgreementData.titleOfAgreement,
        dateOfContract: selectedAgreementData.dateOfContract,
        noOfMonths:
          selectedAgreementData.noOfMonths === null
            ? 0
            : selectedAgreementData.noOfMonths,
        noOfYears:
          selectedAgreementData.noOfYears === null
            ? 0
            : selectedAgreementData.noOfYears,
        location: selectedAgreementData.location,
        businessUnit: parseInt(selectedAgreementData.mapBusinessunit),
        endDate: selectedAgreementData.dueDateOfContract,
        mapRegion: parseInt(selectedAgreementData.mapRegion),
        jobOrder: selectedAgreementData.jobOrder,
        connectedAgreement: selectedAgreementData.id,
        brandName: selectedAgreementData.secondParty?.brandName
          ? selectedAgreementData.secondParty?.brandName
          : "",
        createdBy: userData.name,
        createdById: userData.id,
        createdByEmail: userData.email,
        oneDriveId: selectedAgreementData.oneDriveId,
      });

      setDetails({
        agreementId: selectedAgreementId,
        local: false,
        secondParty: agreementData.secondParty?.name
          ? agreementData.secondParty.name
          : agreementData.secondParty.indi_name,
        parentAgreementId: 0,
        typeOfAgreement: agreementData.typeOfAgreement,
        endDate: selectedAgreementData.dueDateOfContract,
        businessUnit: agreementData.businessUnit,
        mapRegion: agreementData.mapRegion,
        jobOrder: agreementData.jobOrder,
        brandName: agreementData.brandName,
        oneDriveId: agreementData.oneDriveId,
      });

      if (selectedAgreementData.secondParty.name) {
        setSecondPartyDetailsEntity({
          ...secondPartyDetailsEntity,
          name: selectedAgreementData.secondParty.name,
          regAddress: selectedAgreementData.secondParty.address,
          entityType: selectedAgreementData.secondParty.entityType,
        });
        setDetails({
          agreementId: selectedAgreementId,
          local: false,
          secondParty: agreementData.secondParty?.name
            ? agreementData.secondParty.name
            : agreementData.secondParty.indi_name,
          parentAgreementId: 0,
          typeOfAgreement: agreementData.typeOfAgreement,
          endDate: agreementData.endDate,
          businessUnit: agreementData.businessUnit,
          jobOrder: agreementData.jobOrder,
          brandName: agreementData.brandName,
        });
      } else if (selectedAgreementData.secondParty.type === "Individual") {
        setSecondPartyDetailsIndi({
          ...secondPartyDetailsIndi,
          indi_name: selectedAgreementData.secondParty.indi_name,
          fathersname: selectedAgreementData.secondParty.indi_fatherName,
          pan: selectedAgreementData.secondParty.indi_pan,
        });
        setDetails({
          agreementId: selectedAgreementId,
          local: false,
          secondParty: agreementData.secondParty?.name
            ? agreementData.secondParty.name
            : agreementData.secondParty.indi_name,
          parentAgreementId: 0,
          typeOfAgreement: agreementData.typeOfAgreement,
          endDate: agreementData.endDate,
          businessUnit: agreementData.businessUnit,
          mapRegion: agreementData.mapRegion,
          jobOrder: agreementData.jobOrder,
          brandName: agreementData.indi_name,
        });
      }
    }
  }, [selectedAgreementData, selectedAgreementId]);
  const [files, setFiles] = useState([]);
  const [selectFileModal, setSelectFileModal] = useState(false);

  useEffect(() => {
    if (!selectedAgreementId) return;

    const loadAttachedFiles = async () => {
      try {
        // reset previous state
        setSignedFile(null);
        setFiles([]);
        setSelectFileModal(false);

        const signedagreementList = await getAttacchedFiles({
          id: selectedAgreementId,
        });

        const files = signedagreementList?.files || [];

        console.log("Agreement files:", files);

        const docsLockerFile = files.find((file) =>
          file.fileName?.toLowerCase().includes("send to docs locker"),
        );

        if (docsLockerFile) {
          setSignedFile(docsLockerFile);
          return;
        }

        setFiles(files);
        setSelectFileModal(true);
      } catch (err) {
        console.error("Error loading agreement files:", err);
        setFiles([]);
        setSelectFileModal(false);
      }
    };

    loadAttachedFiles();
  }, [selectedAgreementId]);

  AWS.config.update({
    accessKeyId: `${process.env.REACT_APP_AWS_ACCESS_KAY_ID}`,
    secretAccessKey: `${process.env.REACT_APP_AWS_SECRET_ACCESS_KEY}`,
    region: `${process.env.REACT_APP_REGION}`,
  });

  const s3 = new AWS.S3();

  const uploadFileToAws = async (e) => {
    const file = e.target.files[0];

    const fileName = file.name;

    setSignedFile({ ...file, fileName });
    setFileSize(file.size);
    setFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      const arrayBuffer = reader.result;
      setFileBuffer(arrayBuffer); // store array buffer in state
    };

    reader.readAsArrayBuffer(file);
    // reader.readAsArrayBuffer(file);
  };

  const openFile = async (url) => {
    const hostedLink = url;
    console.log("hosted link : ", hostedLink);
    const response = await getReadUrl({ hostedLink });
    console.log("response : ", response);
    if (response.success) {
      window.open(`${response.signedUrl}`, "_blank");
    }
  };

  const deleteFileFromAws = async ({ e, fileId, key }) => {
    e.preventDefault();
    // const params = {
    //   Bucket: `${process.env.REACT_APP_AWS_BUCKET}`,
    //   Key: key,
    // };
    try {
      // const data = await s3.deleteObject(params).promise();
      // console.log("File deleted successfully:", data);
      setSignedFile(null);
    } catch (err) {
      console.error("Error deleting the file:", err);
    }
  };
  const validate = () => {
    const keys = {};
    if (!existsAndLength(agreementData.relationshipType)) {
      keys.relationshipType = "Please check relationship type";
    }
    if (!existsAndLength(agreementData.titleOfAgreement)) {
      keys.titleOfAgreement = "Please check title of agreement";
    }
    if (!existsAndLength(agreementData.typeOfAgreement)) {
      keys.typeOfAgreement = "Please fill type of agreement";
    }
    if (agreementData.businessUnit === 0) {
      keys.businessUnit = "Please fill Business Unit";
    }
    // if (!existsAndLength(agreementData.location)) {
    //   keys.location = "please check location";
    // }
    if (agreementData.noOfMonths + agreementData.noOfYears === 0) {
      keys.duration = "please check duration";
    }
    if (!existsAndLength(agreementData.dateOfContract)) {
      keys.dateOfContract = "please check start date";
    }

    if (!signedFile) {
      keys.files = "please upload a file";
    }
    if (Object.keys(keys).length) {
      showNotification({
        color: "red",
        title: "Service Record",
        message: "Make sure all fields are filled properly.",
      });
      setAgreementData((agreementData) => ({
        ...agreementData,
        errors: keys,
      }));
      return false;
    }
    return true;
  };
  console.log("signed file: ", signedFile);
  const save = async () => {
    setAgreementData({ ...agreementData, errors: {} });

    if (validate()) {
      console.log("agreement data: ", agreementData);
      if (agreementData.agreementId === 0 && agreementData.local) {
        const time =
          365 * agreementData.noOfYears + 30 * agreementData.noOfMonths;
        const endDate = convertToISO8601(
          converDateToISO(
            await getFutureDate(agreementData.dateOfContract, time),
          ),
        );
        const updatedAgreementData = { ...agreementData, endDate: endDate };
        setAgreementData({ ...agreementData, endDate: endDate });
        console.log(agreementData);
        const response = await createLocalAgreement({
          agreementData: updatedAgreementData,
        });
        if (response.success) {
          // setAgreementData({ ...response.agreement, erros: {} });
          const id = response.agreement.agreementId;
          let fileforAttach;
          if (!signedFile.hostedLink) {
            const res = await attachFileToParent({
              fileName: signedFile.fileName,
              parent: "local",
              parentId: parseInt(id),
            });
            const signedUrl = res.signedUrl;
            const responseFile = await fetch(`${signedUrl}`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/octet-stream",
                "Content-Length": fileSize.toString(),
                "Content-Range": `bytes 0-${fileSize - 1}/${fileSize}`,
              },
              body: fileBuffer,
            });
            const result = await responseFile.json();
            const fileId = result.id;
            fileforAttach = {
              createdBy: response.agreement.createdBy,
              createdByUserId: response.agreement.createdById,
              location: fileId,
              name: signedFile.fileName,
              parent: "local",
              parentId: parseInt(id),
              type: "application/pdf",
              extraCol1: fileId,
            };
          } else {
            fileforAttach = {
              createdBy: response.agreement.createdBy,
              createdByUserId: response.agreement.createdById,
              location: signedFile.hostedLink,
              name: signedFile.fileName,
              parent: "local",
              parentId: parseInt(id),
              type: signedFile.type,
              extraCol1: signedFile.hostedLink,
            };
          }
          const fileAttached = await attachFiles({ body: fileforAttach });
          setDetails({
            agreementId: id,
            local: true,
            secondParty: agreementData.secondParty?.name
              ? agreementData.secondParty.name
              : agreementData.secondParty.indi_name,
            parentAgreementId: 0,
            typeOfAgreement: agreementData.typeOfAgreement,
            endDate: updatedAgreementData.endDate,
            businessUnit: agreementData.businessUnit,
            mapRegion: agreementData.mapRegion,
            jobOrder: agreementData.jobOrder,
            brandName: agreementData.brandName,
          });
          setLoading(false);
          setUiConfigs({ currentStep: 1 });
        } else {
          alert("error h bhau");
          setLoading(false);
        }
      } else if (agreementData.agreementId > 0 && !agreementData.local) {
        const date = agreementData.dateOfContract;
        // setAgreementData({...agreementData, dateOfContract: convertToISO(date) });
        const response = await createLocalAgreement({ agreementData });
        if (response.success) {
          // setAgreementData({ ...response.agreement, erros: {} });
          const id = response.agreement.agreementId;
          const fileforAttach = {
            createdBy: "virendra",
            createdByUserId: 1,
            location: signedFile.hostedLink,
            name: signedFile.fileName,
            parent: "local",
            parentId: parseInt(id),
            type: signedFile.mimeType,
            extraCol1: signedFile.hostedLink?.split("/").pop(),
          };
          const fileAttached = await attachFiles({ body: fileforAttach });
          setDetails({
            agreementId: id,
            local: true,
            secondParty: agreementData.secondParty?.name
              ? agreementData.secondParty.name
              : agreementData.secondParty.indi_name,
            parentAgreementId: 0,
            typeOfAgreement: agreementData.typeOfAgreement,
            endDate: agreementData.endDate,
            businessUnit: agreementData.businessUnit,
            mapRegion: agreementData.mapRegion,
            brandName: agreementData.brandName,
            jobOrder: agreementData.jobOrder,
          });

          setUiConfigs({ currentStep: 1 });
          setLoading(false);
        } else {
          alert("error h bhau", response);
          setLoading(false);
        }
      }
    }
  };
  const handleCreate = (newItem) => {
    setCategoryOptions((current) => [...current, newItem]);
    setAgreementData({ ...agreementData, typeOfAgreement: newItem });
  };
  const handleNameCreate = (newItem) => {
    setNameOptions((current) => [...current, newItem]);
    setAgreementData({ ...agreementData, titleOfAgreement: newItem });
  };
  const updatedNameOptions = nameOptions.some(
    (option) => option.value === agreementData.titleOfAgreement,
  )
    ? nameOptions
    : [
        ...nameOptions,
        {
          value: agreementData.titleOfAgreement,
          label: agreementData.titleOfAgreement,
        },
      ];
  const updatedCategoryOptions = categoryOptions.some(
    (option) => option.value === agreementData.typeOfAgreement,
  )
    ? categoryOptions
    : [
        ...categoryOptions,
        {
          value: agreementData.typeOfAgreement,
          label: agreementData.typeOfAgreement,
        },
      ];

  console.log("agreement data: ", agreementData);
  console.log("files: ", files);
  console.log("signedFile: ", signedFile);

  return (
    <>
      <div className="grid grid-cols-4 gap-4">
        <div className="flex items-center gap-2 ">
          <input
            type="checkbox"
            checked={useExisting}
            onChange={(e) => setUseExisting(e.target.checked)}
          />
          <label htmlFor="local">Use Existing Contract</label>
        </div>

        {useExisting && (
          <div
            className="flex items-center "
            style={{ width: "100%", marginRight: "10%", position: "relative" }}
          >
            <TextInput
              label="Connected Contract"
              placeholder="Enter contract number"
              type="number"
              value={selectedAgreementId}
              readOnly
              style={{
                width: "58%",
                marginRight: "2%",
                // marginLeft: "25%"
              }}
            />
            <Button
              className="flex items-center justify-center"
              onClick={(e) => setShowModal(true)}
              style={{
                backgroundColor: "#1b6f8d",
                width: "20%",
                marginRight: "20%",
                position: "absolute",
                bottom: "0",
                right: "0",
                padding: "0",
              }}
            >
              <IconSearch size={20} strokeWidth={3} />
            </Button>
          </div>
        )}
      </div>

      <div className="w-full flex flex-col mt-2">
        <div className="grid grid-cols-4 gap-4">
          <TextInput
            label="Job Order"
            className="max-w-lg"
            placeholder="Enter Job Order"
            value={agreementData.jobOrder}
            onChange={(e) =>
              setAgreementData({ ...agreementData, jobOrder: e.target.value })
            }
          />
          <Select
            searchable
            required
            className="max-w-lg"
            label="Type of Document"
            placeholder="Select Type of Document"
            data={typeOfDocuments}
            value={agreementData.relationshipType}
            onChange={(val) => {
              selectedAgreementId === 0 &&
                setAgreementData({ ...agreementData, relationshipType: val });
            }}
            error={agreementData.errors?.relationshipType}
          />
          {/* {agreementData.relationshipType!=="Parent" &&
          <div>
            <TextInput
              required
              className="max-w-lg"
              label="select Parent agreement Id"

            />
          </div>} */}
          <Select
            searchable
            required
            className="max-w-lg"
            label="Contract Category"
            placeholder="Select Contract Category"
            data={updatedCategoryOptions}
            creatable
            onSearchChange={(val) => setSearchCategory(val)}
            getCreateLabel={(query) => `+ Add "${query}"`}
            onCreate={handleCreate}
            onChange={(value) => {
              setAgreementData({ ...agreementData, typeOfAgreement: value });
            }}
            value={agreementData.typeOfAgreement}
            error={agreementData.errors?.typeOfAgreement}
          />
          <Select
            searchable
            required
            className="max-w-lg"
            label="Contract Title"
            placeholder="Select Contract Title"
            data={updatedNameOptions}
            creatable
            onSearchChange={(val) => setSearchName(val)}
            onCreate={handleNameCreate}
            getCreateLabel={(query) => `+ Add "${query}"`}
            onChange={(Selected) => {
              {
                selectedAgreementId === 0 &&
                  setAgreementData({
                    ...agreementData,
                    titleOfAgreement: Selected,
                  });
              }
            }}
            value={agreementData.titleOfAgreement}
            error={agreementData.errors?.titleOfAgreement}
          />
        </div>
        <Divider className="mt-4" />
        <Text size="md" color="#1b6f8d">
          term & location
        </Text>
        <div className="grid grid-cols-4 gap-4">
          <DatePicker
            required
            style={{ marginBottom: "20px", marginRight: "4%" }}
            label="Starting Date"
            placeholder="Select Starting Date"
            value={
              agreementData.dateOfContract
                ? new Date(agreementData.dateOfContract)
                : null
            }
            onChange={async (val) => {
              console.log("date: ");

              setAgreementData({
                ...agreementData,
                dateOfContract: await convertToISO8601(converDateToISO(val)),
              });
            }}
            error={agreementData.errors?.dateOfContract}
          />
          <div className="flex flex-row" style={{ marginBottom: "20px" }}>
            <Select
              required
              label="Duration"
              placeholder="Select Years"
              data={[
                ...Array.from({ length: 11 }, (_, i) => ({
                  value: i.toString(),
                  label: `${i} year${i === 1 ? "" : "s"}`,
                })),
                { value: "100", label: "100 Years" }, // Add the option for 100 years
              ]}
              onChange={(selectedOption) => {
                setAgreementData({
                  ...agreementData,
                  noOfYears: Number(selectedOption),
                });
              }}
              value={agreementData.noOfYears?.toString()}
              style={{ width: "160px", marginRight: "20px" }}
              error={agreementData.errors?.duration}
            />
            <Select
              label="   "
              placeholder="Select Months"
              data={[
                { value: "0", label: "0 month" },
                ...Array.from({ length: 12 }, (_, i) => ({
                  value: (i + 1).toString(),
                  label: `${i + 1} month${i === 0 ? "" : "s"}`,
                })),
              ]}
              onChange={(selectedOption) => {
                setAgreementData({
                  ...agreementData,
                  noOfMonths: Number(selectedOption),
                });
              }}
              value={agreementData.noOfMonths?.toString()}
              style={{ width: "160px" }}
            />
          </div>
          {/* <Select
              style={{ marginBottom: "20px", width: "37%", marginRight: "4%" }}
              required
              searchable
              placeholder="enter location"
              label="location"
              data={[...INDIA_STATES_UNIONS]}
              value={agreementData.location}
              onChange={(val) => {
                {
                  selectedAgreementId === 0 &&
                    setAgreementData({
                      ...agreementData,
                      location: val,
                    });
                }
              }}
              error={agreementData.errors?.location}
            /> */}
          {buData !== null && (
            <Select
              required
              searchable
              placeholder="Enter Business Unit"
              label="Business Unit"
              data={buData}
              value={agreementData.businessUnit?.toString()}
              onChange={(val) => {
                setAgreementData({
                  ...agreementData,
                  businessUnit: val,
                });
              }}
              // value={legacyAgreementFormValue.businessUnit}
              dropdownPosition="bottom"
              error={agreementData.errors?.businessUnit}
            />
          )}
          <Select
            label="Business Region"
            data={regions}
            placeholder="Select Business Region"
            onChange={(val) =>
              setAgreementData({ ...agreementData, mapRegion: val })
            }
            value={agreementData.mapRegion?.toString()}
          />
          {/* <TextInput required label="Location" placeholder='Enter location' {...legacyAgreementFormValue.getInputProps('location')}/> */}
        </div>
      </div>
      <Divider className="my-2" />
      <>
        <div className="flex flex-col">
          <div className="flex justify-between">
            <Text color="#1b6f8d">second party details</Text>
            <SegmentedControl
              value={type}
              color="primary"
              data={["Entity", "Individual"]}
              onChange={(val) => {
                setType(val);
              }}
            />
          </div>
          <div className="grid grid-cols-4 gap-4">
            {type === "Entity" && (
              <>
                <Select
                  required
                  className="inputCustom "
                  label="Entity Type"
                  style={{
                    width: "100%",
                    marginLeft: "0px",
                    lineHeight: "1.55",
                  }}
                  data={[
                    { value: "Company", label: "Company" },
                    { value: "LLP", label: "LLP" },
                    { value: "Partnership Firm", label: "Partnership Firm" },
                    { value: "Sole Proprietary", label: "Sole Proprietary" },
                    { value: "Trust", label: "Trust" },
                    {
                      value: "Government Department",
                      label: "Government Department",
                    },
                  ]}
                  value={secondPartyDetailsEntity.entityType}
                  onChange={(selectedOption) => {
                    setSecondPartyDetailsEntity({
                      ...secondPartyDetailsEntity,
                      entityType: selectedOption,
                    });
                  }}
                />
                <TextInput
                  required
                  className="inputCustom"
                  label="Registered Name"
                  placeholder="Enter Registered Name"
                  value={secondPartyDetailsEntity.name}
                  onChange={(e) => {
                    setSecondPartyDetailsEntity({
                      ...secondPartyDetailsEntity,
                      name: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    lineHeight: "1.55",
                  }}
                />
                <TextInput
                  label="Brand Name"
                  placeholder="Enter Brand Name"
                  value={agreementData.brandName}
                  onChange={(e) =>
                    setAgreementData({
                      ...agreementData,
                      brandName: e.target.value,
                    })
                  }
                />
                <Textarea
                  label="Registered Address"
                  placeholder="Enter Registered Address"
                  rows={1}
                  value={secondPartyDetailsEntity.regAddress || ""}
                  onChange={(e) =>
                    setSecondPartyDetailsEntity({
                      ...secondPartyDetailsEntity,
                      name: selectedAgreementData.secondParty.name || "",
                      regAddress:
                        selectedAgreementData.secondParty.address || "",
                      entityType:
                        selectedAgreementData.secondParty.entityType || "",
                    })
                  }
                />
              </>
            )}
            {type === "Individual" && (
              <>
                <TextInput
                  required
                  label="Individual Name"
                  placeholder="Enter Individual Name"
                  value={secondPartyDetailsIndi.indi_name}
                  onChange={(e) => {
                    setSecondPartyDetailsIndi({
                      ...secondPartyDetailsIndi,
                      indi_name: e.target.value,
                    });
                  }}
                />
                <TextInput
                  label="Father's Name"
                  placeholder="Enter Father's Name"
                  value={secondPartyDetailsIndi.fathersname}
                  onChange={(e) => {
                    setSecondPartyDetailsIndi({
                      ...secondPartyDetailsIndi,
                      fathersname: e.target.value,
                    });
                  }}
                />
                <TextInput
                  label="PAN no."
                  placeholder="Enter PAN no."
                  value={secondPartyDetailsIndi.pan}
                  onChange={(e) => {
                    setSecondPartyDetailsIndi({
                      ...secondPartyDetailsIndi,
                      pan: e.target.value,
                    });
                  }}
                />
              </>
            )}
          </div>
        </div>
        <Divider className="mt-2" />
        <Text color="#1b6f8d" className="my-2">
          upload contract
        </Text>

        {signedFile === null && (
          <>
            {/* <div className="flex justify-center">
              <Button
                style={{
                  backgroundColor: "#1b6f8d",
                }}
                onClick={() => setDocumentModal(true)}
              >
                choose from documents
              </Button>
            </div> */}
            {/* <div className="flex items-center my-3">
              <hr className="flex-grow border-dotted border-t-2 gap-2 border-gray-400" />
              <span className="mx-2 text-gray-600">or</span>
              <hr className="flex-grow border-dotted border-t-2 border-gray-400" />
            </div> */}

            <div
              error={agreementData.errors?.files}
              className="flex items-center justify-center w-full"
            >
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-35 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer"
              >
                <div className="flex flex-col items-center justify-center pt-2 pb-2">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    pdf
                  </p>
                </div>
                <input
                  onChange={async (e) => {
                    uploadFileToAws(e);
                  }}
                  accept=".pdf"
                  id="dropzone-file"
                  type="file"
                  className="hidden"
                />
              </label>
            </div>
          </>
        )}
        <div className="mt-4">
          {signedFile && (
            <div className="flex block h-10 mb-4 w-fulll">
              <div className="center w-1/12 inline-block">
                <svg
                  width="24"
                  height="35"
                  viewBox="0 0 24 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 9.29688V0H1.5C0.66875 0 0 0.731445 0 1.64062V33.3594C0 34.2686 0.66875 35 1.5 35H22.5C23.3312 35 24 34.2686 24 33.3594V10.9375H15.5C14.675 10.9375 14 10.1992 14 9.29688ZM18.0737 24.0632H14V29.5319C14 30.1362 13.5525 30.6257 13 30.6257H11C10.4475 30.6257 10 30.1362 10 29.5319V24.0632H5.92625C5.03375 24.0632 4.58813 22.8813 5.22188 22.1929L11.2481 15.6509C11.6637 15.199 12.335 15.199 12.7506 15.6509L18.7769 22.1929C19.4112 22.8813 18.9662 24.0632 18.0737 24.0632ZM23.5625 7.17773L17.4438 0.478516C17.1625 0.170898 16.7812 0 16.3813 0H16V8.75H24V8.33301C24 7.90234 23.8438 7.48535 23.5625 7.17773Z"
                    fill="#191D23"
                  />
                </svg>
              </div>
              <div className="flex flex-col pl-3 w-full">
                <div className="flex flex-row justify-between">
                  <div
                    style={{
                      lineHeight: "1.25rem",
                      letterSpacing: "-0.0313rem",
                      color: "#191D23",
                    }}
                  >
                    {signedFile.name ? signedFile.name : signedFile.fileName}
                  </div>
                </div>
                <div className="mt-3">
                  <Progress
                    color={signedFile.errored ? "red" : "teal"}
                    size="sm"
                    value={100}
                  />
                </div>
              </div>
              <div className="center inline-block">
                {/* <a href={url} target="blank"> */}
                <Button
                  className="mx-3 w-60"
                  color="#1b6f8d"
                  variant="outline"
                  style={{
                    color: "#1b6f8d",
                    borderColor: "#1b6f8d",
                  }}
                  onClick={() => {
                    if (signedFile.hostedLink) {
                      openFile(signedFile.hostedLink);
                    } else {
                      showNotification({
                        color: "red",
                        message: "uploaded file locally",
                      });
                    }
                  }}
                >
                  Open
                </Button>
                {/* </a> */}
              </div>
              <div className="center w-1/12 px-auto py-auto inline-block">
                <IconTrash
                  onClick={(e) =>
                    deleteFileFromAws({
                      e,
                      fileId: signedFile.id,
                      key: signedFile.key,
                    })
                  }
                  className="mx-auto"
                  size={30}
                  color="#1b6f8d"
                />
              </div>
            </div>
          )}
        </div>
      </>
      <div className="flex flex-row justify-between">
        <div></div>
        <Button
          loading={loading}
          className="max-w-xs right mt-5"
          style={{
            backgroundColor: "#1b6f8d",
          }}
          onClick={(e) => {
            setLoading(true);
            save(e);
          }}
        >
          Next
        </Button>
      </div>
      <Modal
        onClose={() => setShowModal(false)}
        opened={showModal}
        title="search connected contract"
        size="calc(80vw)"
      >
        <SignedAgreementListModal
          setSelectedAgreementData={setSelectedAgreementData}
          setSelectedAgreementId={setSelectedAgreementId}
          setShowModal={setShowModal}
        />
      </Modal>
      <Modal
        key={selectedAgreementId}
        opened={selectFileModal}
        onClose={() => setSelectFileModal(false)}
        title={
          <Text fw={600} size="lg">
            Select Signed File
          </Text>
        }
        size="70%"
        centered
        radius="md"
      >
        <div className="max-h-[500px] overflow-y-auto">
          {files.length === 0 ? (
            <div
              className="flex flex-col items-center justify-center text-center"
              style={{ minHeight: 300 }}
            >
              <IconFile size={72} color="#cbd5e1" />

              <Text size="lg" fw={600} mt="md">
                No signed files found
              </Text>

              <Text size="sm" c="dimmed" mt={4}>
                No documents are attached with this agreement.
              </Text>

              <Text size="sm" c="dimmed">
                Please upload a signed agreement or send the agreement to Docs
                Locker first.
              </Text>
            </div>
          ) : (
            files.map((file) => (
              <div
                key={file.id || file.hostedLink || file.fileName}
                className="
                flex items-center justify-between
                p-4 mb-3
                border border-gray-200
                rounded-lg
                hover:bg-gray-50
                transition-all
                cursor-pointer
              "
                onClick={() => {
                  setSignedFile(file);
                  setSelectFileModal(false);
                }}
              >
                <div className="flex items-center gap-4 flex-1 min-w-0">
                  <Checkbox
                    checked={signedFile?.hostedLink === file.hostedLink}
                    readOnly
                  />

                  <IconFile size={30} color="#6b7280" />

                  <div className="truncate">
                    <Text fw={500} className="truncate">
                      {file.fileName}
                    </Text>

                    <Text size="xs" c="dimmed">
                      Signed Agreement
                    </Text>
                  </div>
                </div>

                <Button
                  variant="light"
                  color="blue"
                  radius="md"
                  onClick={(e) => {
                    e.stopPropagation();
                    openFile(file.hostedLink);
                  }}
                >
                  Open
                </Button>
              </div>
            ))
          )}
        </div>
      </Modal>
      {/* <Modal
        opened={docuementModal}
        onClose={() => setDocumentModal(false)}
        size="calc(80vw)"
        title="existing documents"
      >
        <DocumentsModal
          setSignedFile={setSignedFile}
          setDocumentsModal={setDocumentModal}
        />
      </Modal> */}
    </>
  );
};

export default LegacyAgreementForm1;
